import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Filter as FilterModel } from '../../models/filter';
import { Gender } from '../../models/gender';
import { ProductCategory } from '../../models/product-category';
import { DesignTheme } from '../../models/design-theme';
import { Size } from '../../models/size';
import { Color } from '../../models/color';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-filter',
  imports: [CommonModule, FormsModule],
  templateUrl: './filter.html',
  styleUrl: './filter.scss'
})
export class Filter implements OnInit {
  private route = inject(ActivatedRoute)
  @Input() colors: Color[] | null = null;
  @Input() gender: string[] | null = null;
  @Input() categories: string[] | null | any[] = null;
  @Input() themes: string[] | null = null;
  @Input() sizes: string[] | null = null;
  @Input() filters: FilterModel = {
    gender: null,
    categories: [],
    color: null,
    themes: [],
    sizes: [],
    price: 0
  };

  // @Output() filtersChanged = new EventEmitter<any>();
  @Output() apply = new EventEmitter<void>();

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const category = params['category'];
      if (category && !this.filters.categories.includes(category)) {
        this.filters.categories.push(category);
      }
      this.applyFilters();
      // Filter products here
    });
  }

  toggleCategory(category: string) {
    if (!this.filters.categories) {
      this.filters.categories = [];
    }

    const index = this.filters.categories.indexOf(category as ProductCategory);

    if (index === -1) {
      // add category
      this.filters.categories.push(category as ProductCategory);
    } else {
      // remove category
      this.filters.categories.splice(index, 1);
    }
  }


  setColor(color: Color | null) {
    if (this.filters.color === color) {
      this.filters.color = null;
    } else {
      this.filters.color = color;
    }
  }

  setGender(g: string) {
    if (g == this.filters.gender)
      this.filters.gender = null;
    else
      this.filters.gender = g as Gender;
  }

  applyFilters() {
    this.apply.emit();
  }

  toggleTheme(theme: string) {
    const index = this.filters.themes.indexOf(theme as DesignTheme);

    if (index === -1) {
      this.filters.themes.push(theme as DesignTheme);
    } else {
      this.filters.themes.splice(index, 1);
    }
  }

  toggleSize(size: string) {
    const index = this.filters.sizes.indexOf(size as Size);

    if (index === -1) {
      this.filters.sizes.push(size as Size);
    } else {
      this.filters.sizes.splice(index, 1);
    }
  }


}
